document.addEventListener("DOMContentLoaded", function () {
  slideDown();
  closeSelectVariants();
});

function slideDown() {
  var slideTag = document.querySelector(".availability.a-info")
  var orderInfo = document.querySelector(".order-info")
  if (orderInfo) {
    slideTag.addEventListener("click", function () {

      if (orderInfo.classList.contains("order-info-visible")) {
        orderInfo.classList.remove("order-info-visible")

      } else {
        orderInfo.classList.add("order-info-visible")

      }
    });
  }
}

function closeSelectVariants() {
  if($('.variations-box').length) {
    $(document).mouseup(function(e) {
      var container = $('.variations-box');
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        $('.variations-box').removeClass('is-open');
      }
    });
  }
}